import ApiInfoService from '../services/ApiInfo';
import AuthService from '../services/AuthService';

export const useApiDocViewModel = () => {
  const handleRequestApiKey = async () => {
    if (!window.confirm('Apply for an APIKey?')) {
      return;
    }

    try {
      await ApiInfoService.applyAppKey();
      alert('Apply successfully. Please check your email.');
    } catch (error) {
      console.error('Failed to request API key:', error);
      alert('Apply failed.');
      AuthService.logoutWhenError(error);
    }
  };

  return {
    apiInfo: ApiInfoService.apiInfo,
    handleRequestApiKey,
  };
};

export default useApiDocViewModel;